<template>
  <div>
    <!-- <tooltip label="Contacts" type="default" placement="left">
      <a class="button button-table is-small" @click="contact()">
        <i class="fa fa-address-card"></i>
      </a>
    </tooltip>
    <tooltip label="Comments" type="default" placement="left">
      <a class="button button-table is-small" @click="comments()">
        <i class="fa fa-comment-o"></i>
      </a>
    </tooltip> -->
    <!-- <tooltip label="Hotels" type="default" placement="left">
      <a class="button button-table is-small" @click="hotels()">
        <i class="fa fa-building"></i>
      </a>
    </tooltip> -->
    <tooltip label="Edit" type="default" placement="left">
      <a class="button button-table is-small" @click="edit()">
        <i class="fa fa-pencil"></i>
      </a>
    </tooltip>
    <!-- <tooltip label="Call Log" type="default" placement="left">
      <a class="button button-table is-small" @click="call()">
        <i class="fa fa-phone"></i>
      </a>
    </tooltip> -->
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import Message from '../../utils/message'
  import Chain from './ChainsHotel'
  import Contact from './contact'
  import Call from './call'
  import Comment from './comment'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      edit () {
        let propsData = {
          context: this,
          chain_hotel_id: this.data.id,
          title: 'Edit Chain - ' + this.data.name,
          callback: 'chainCallback',
          edit: true
        }
        Chain.openChain(propsData)
      },
      chainCallback (result) {
        let propsData = null
        if (result.ok) {
          propsData = {
            title: 'Success',
            message: result.message,
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          this.$parent.loadData()
        }
        Message.openMessage(propsData)
      },
      contact () {
        let propsData = {
          context: this,
          chain_id: this.data.id,
          title: 'Chain - ' + this.data.name,
          callback: 'chainCallback'
        }
        Contact.openContacts(propsData)
      },
      // hotels () {
      //   let propsData = {
      //     context: this,
      //     chain_id: this.data.id,
      //     title: 'Chain - ' + this.data.name,
      //     callback: 'chainCallback'
      //   }
      //   Chain.openChainHotels(propsData)
      // },
      call () {
        let propsData = {
          context: this,
          chain_id: this.data.id,
          title: 'Chain - ' + this.data.name,
          callback: 'chainCallback'
        }
        Call.openCallLogs(propsData)
      },
      comments () {
        let propsData = {
          context: this,
          chain_id: this.data.id,
          title: 'Chain - ' + this.data.name,
          callback: 'chainCallback'
        }
        Comment.openComments(propsData)
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ChainsHotelTableButtons.vue?18db4fb4